import { RepairShop } from "../../../model/RepairShop";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import { HttpResponse } from "../../../network/types";

import { RepairshopEditRequestBody, ResetPassRequest } from "./types";

export const editRepairshop = async (
  requestBody: RepairshopEditRequestBody
) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.PUT,
    url: `/repair-shops/me`,
    requestBody: { ...requestBody, service: "TIREPICK" },
  });
  return response?.data;
};
export const getRepairshopInfo: () => Promise<RepairShop> = async () => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: `/repair-shop-info/me`,
  });
  return response?.data.row;
};
export const resetPass = async (requestBody: ResetPassRequest) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.PUT,
    url: `/repair-shops/this/password`,
    requestBody,
  });
  return response?.data.row;
};
